export default {
  namespaced: true,
  state: {
    general: {},
    pages: {},
    chapters: {},
  },
  mutations: {
    'SET_DATA' (state, res) {

      if(res.type == 'general')
        state.general = res.data.acf

      if(res.type == 'pages')
        _.each(res.data, data => state.pages[data.acf.admin.route_key] = {  ...data.acf, id: data.id  })

      if(res.type == 'chapters') {
        state.chapters = _.map(res.data, data => ({ id: data.id, ...data.acf }))
        _.each(state.chapters, (chapter, index) => {
          state.chapters[index]['index'] = index
          state.chapters[index]['$howler'] = null
          state.chapters[index]['$pixi'] = null
          state.chapters[index]['$loader'] = null
          state.chapters[index]['$tl'] = null
          state.chapters[index]['videoURL'] = chapter.video
          state.chapters[index]['$video'] = null
          if(chapter.key != 'introduction') {
            const json = JSON.parse(chapter.audio.json)
            const ambianceKeys = {}
            _.each(json.sprite, (s,k) => {
              if(k.search('MUS') > -1 || k.search('SND_01_LOOP') > -1) {
                json.sprite[k].push(true)
                ambianceKeys[k] = null
              }
            })
            state.chapters[index].audio['ambiences'] = ambianceKeys
            state.chapters[index].audio.json = json
            state.chapters[index].audio.subtitles = JSON.parse(chapter.audio.subtitles)
          }
          _.each(chapter.biorythme, (rythme, ri) => {
            const a = rythme.start_at.split(':')
            state.chapters[index].biorythme[ri]['start_at_seconds'] = (+a[0]) * 60 * 60 + (+a[1]) * 60 + (+a[2])
          })
        })
      }
    },
  },
  getters: {
    general: state => state.general,
    pages: state => state.pages,
    chapters: state => state.chapters
  }
}
